import React from 'react';
import styles from "./HocSinhNameAndAvavtar.module.css";

interface HocSinhProps {
  ho_ten?: string;
  ma_hs?: string;
  ma_tn?: string;
  avatar?: string;
}

interface HocSinhNameAndAvatarProps {
  hocSinh: HocSinhProps;
}

const HocSinhNameAndAvavtar: React.FC<HocSinhNameAndAvatarProps> = ({ hocSinh }) => {
  return (
    <div className={styles.container}>
      <div className={styles.avatar}>
        <div
          style={{
            backgroundImage: `url(${hocSinh.avatar ? hocSinh.avatar : '../../../images/hs_avatar.png'})`,
            width: 50,
            height: 50,
            backgroundSize: 'cover',
            borderRadius: '50%',
          }}
        />
      </div>
      <div className={styles.info}>
        <div className={styles.ho_ten}>{hocSinh.ho_ten}</div>
        <div className={styles.ma_hs}>{hocSinh.ma_hs ? hocSinh.ma_hs : hocSinh.ma_tn}</div>
      </div>
    </div>
  );
};

export default HocSinhNameAndAvavtar;
